import { Localized } from "@robe/core-types";
import { parseQueryParamsObject } from "@robe/core-utils";
import { XcoreCore } from "XcoreCore";
import { BaseApiRequest } from "../baseApiRequest";

export interface ContentSlug {
  contentId: number;
  contentType: string;
  localizedSlugs: Localized;
}

/**
 * Get slugs for specific contents by contents IDs.
 * Probably used only to resolve content slugs for richtext links in get content / contents.
 */
export const getContentSlugsByIds = (core: XcoreCore, ids: number[]): BaseApiRequest<Array<ContentSlug>> =>
  core.fetch(`/api/content/localized/slugs${parseQueryParamsObject({ ids })}`).then((res) => res.json());
